module.exports = __webpack_public_path__ + "static/GNT3-0e859449d5ac4881709ac0f7fa0ce7d8.jpg";